import { Link } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { PageHeader, Spinner } from "../components/AiHtml";

export default function Employees() {
  const { config } = useAuth();
  return (
    <div>
      <PageHeader label="Your AI team" title="10 AI Employees" desc="Each employee is a specialist. Every chat message costs 1 credit and is saved to your history." />
      {!config && <Spinner label="Loading your AI team..." />}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {(config?.employees || []).map((e, i) => (
          <Link key={e.id} to={`/employees/${e.id}`} data-testid={`employee-card-${e.id}`} style={{ animationDelay: `${i * 40}ms` }}
            className="card-n p-5 fade-up group hover:border-orange-500/60 hover:-translate-y-0.5 transition-[transform,border-color] duration-200">
            <div className="flex items-center justify-between">
              <div className="relative w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-orange-700 grid place-items-center font-display font-bold text-xl">{e.name[0]}
                <span className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-emerald-400 ring-2 ring-[#0F172A]" />
              </div>
              <span data-testid={`employee-status-${e.id}`} className="inline-flex items-center gap-1.5 text-[11px] px-2 py-0.5 rounded-full bg-emerald-500/10 text-emerald-400 border border-emerald-500/20"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" /> Active</span>
            </div>
            <p className="font-display font-semibold text-lg mt-4">{e.name}</p>
            <p className="text-xs text-orange-400">{e.role}</p>
            <p className="text-xs text-slate-500 mt-2 line-clamp-3">{e.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-xs text-slate-400 group-hover:text-orange-400"><MessageSquare size={13} /> Start chat</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
